// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/sass/colors/blue.scss
// module id = 588
// module chunks = 376